export default __webpack_public_path__ + "static/media/product3.16997bd0.png";